import { RequireChildrenFor } from "@omni/types/components/utils/children.types";
import { cn } from "@omni/utils/styles";

import { usePaintConfiguratorContext } from "../../context/paintConfigurator.context";
import { FamiliesContextProvider } from "./context/families.context";

const Base = ({ children }: RequireChildrenFor<{}>) => {
    const { selectedCollection } = usePaintConfiguratorContext();
    return (
        <div
            className={cn(
                "tw:grid tw:grid-cols-2 tw:md:grid-cols-4 tw:lg:grid-cols-5 tw:gap-4 tw:md:gap-6 tw:lg:gap-8"
            )}
        >
            <FamiliesContextProvider selectedCollection={selectedCollection}>
                {children}
            </FamiliesContextProvider>
        </div>
    );
};

export { Base };
